import React from 'react';
import Logo from '../UI/Logo';
import NavigationItems from './NavigationItems';

const SideDrawer = props => {
    const classList = ['side-drawer'];
    if (props.open)
        classList.push('side-drawer--enable');
    return (
        <div className={classList.join(' ')} onClick={props.closed}>
            <div className="side-drawer__logo">
                <Logo />
            </div>
            <NavigationItems />
        </div>
    );
}

export default SideDrawer;